import React from "react";

interface SpinnerProps {
  size?: "sm" | "md" | "lg" | "xl";
  className?: string;
}

const Spinner: React.FC<SpinnerProps> = ({ size = "lg", className = "" }) => {
  const sizeClasses = {
    sm: "text-sm",
    md: "text-lg",
    lg: "text-2xl",
    xl: "text-4xl",
  };

  return (
    <i
      className={`pi pi-spin pi-spinner text-primary ${sizeClasses[size]} ${className}`}
    />
  );
};

export default Spinner;
